import PanindaDemo from '../../../assets/projects/panindamobile.mp4';
import { PANINDA_FEATURES, PANINDA_TAGS } from '../../../constants';
import { ProjectModal } from './ProjectModal';

export const PanindaModal = ({ isOpen, onClose }) => (
  <ProjectModal
    isOpen={isOpen}
    onClose={onClose}
    number="01"
    title="Paninda Mobile"
    category="Mobile application"
    role="Frontend Developer"
    status="Completed school project"
    summary="An all-in-one store assistant that helps small and medium-sized retailers manage inventory, transactions, and sales in one place."
    features={PANINDA_FEATURES}
    tags={PANINDA_TAGS}
    video={PanindaDemo}
    sourceUrl="https://github.com/jamardines-dev/PanindaMobile_Frontend"
    theme="green"
  />
);
